import { vinSchema } from "@qivia/schemas-shared";
import { z } from "zod";

export const createVehiclesForSeederPayloadSchema = z.object({
  vehicleUuid: z.uuid(),
  companyUuid: z.uuid(),
  vin: vinSchema,
  brand: z.string(),
  odometers: z.array(
    z.object({
      vin: z.string(),
      mileage: z.number(),
      date: z.iso.datetime(),
    }),
  ),
  trips: z.array(
    z.object({
      startDate: z.iso.datetime(),
      endDate: z.iso.datetime(),
      distance: z.number().nullable(),
      secondsDuration: z.number().nullable(),
      totalFuelConsumptionInLiter: z.number().nullable(),
      totalElectricConsumption: z.number().nullable(),
      ecoDrivingScore: z.number().nullable(),
      smoothnessScore: z.number().nullable(),
      supSpeedScore: z.number().nullable(),
    }),
  ),
});

export type CreateVehiclesForSeederPayload = z.infer<
  typeof createVehiclesForSeederPayloadSchema
>;
